import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  GreenBackgroundText,
  GreenBackgroundWrapper,
  GreenStationImageLeft,
  GreenStationImageRight,
} from './GreenBackGroundStyled'
import { Container } from '../CommonStyled/CommonStyled'
import { Col, Row } from 'antd'
import { useInView } from 'react-intersection-observer'
import { useParams } from 'react-router-dom'
import { buildPath, handleClickMenu, renderImageByBreakPoint } from '../../utils/common'
import { breakPointState } from '../../recoil/commonState'
import { useRecoilValue } from 'recoil'
import config from '../../config'
import DangerouslySetInnerHtml from '../DangerouslySetInnerHtml'
import { BREAKPOINT } from '../../constant'

const GreenBackGround = props => {
  const { id, mode, greenData } = props
  const { ref: trackRef, inView: isElementInView } = useInView()
  const { id: elementId } = useParams()
  const breakPoint = useRecoilValue(breakPointState)

  const element = document.getElementById(elementId)

  useEffect(() => {
    if (!element) return
    setTimeout(() => {
      handleClickMenu(elementId, mode)
    }, 100)
  }, [element])

  return (
    <GreenBackgroundWrapper
      ref={trackRef}
      id={id}
      backgroundImage={renderImageByBreakPoint(breakPoint, {
        computer: buildPath(greenData?.backgroundImages?.computer),
        tablet: buildPath(greenData?.backgroundImages?.tablet),
        mobile: buildPath(greenData?.backgroundImages?.mobile),
      })}
    >
      <Container>
        <Row gutter={[16, 16]}>
          <Col xxl={12} sm={12} xs={24} className={'leftCol'}>
            {/*<GreenBackgroundImg>*/}
            {/*  <animated.div className='card' style={{ transform }}>*/}
            {/*    <VpFlower src={IMAGES.VP_FLOWER} alt={'vp-flower'} />*/}
            {/*  </animated.div>*/}
            {/*  <FlowerText src={imgLeft} alt={'text-station'} />*/}
            {/*</GreenBackgroundImg>*/}
            {
              greenData?.introductoryImages?.image1 &&
              <GreenStationImageLeft src={buildPath(greenData?.introductoryImages?.image1)} alt={'img-station'} />
            }
          </Col>
          <Col xxl={12} sm={12} xs={24} className={'rightCol'}>
            {/*<GreenStationImageRight src={imgRight} alt={'img-station'} />*/}
            {/*<GreenBackgroundText>{rightText}</GreenBackgroundText>*/}
            {
              (greenData?.introductoryImages?.image2 && breakPoint !== BREAKPOINT.SM && breakPoint !== BREAKPOINT.XS) &&
              <GreenStationImageRight src={buildPath(greenData?.introductoryImages?.image2)} alt={'img-station'} />
            }
            <GreenBackgroundText>
              <DangerouslySetInnerHtml html={greenData?.content} />
            </GreenBackgroundText>
          </Col>
        </Row>
      </Container>
    </GreenBackgroundWrapper>
  )
}

GreenBackGround.propTypes = {
  id: PropTypes.any,
  mode: PropTypes.any,
  data: PropTypes.any,
}

export default GreenBackGround
